// extracted by mini-css-extract-plugin
export default {"zoomModal":"b1-z"};